import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { InspectionEntryDescriptor } from './model/inspection.entry';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class InspectionEntryService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'InspectionEntryManagement',
      authService,
      config.INMSConfig
    );

  }

  public create(inspectionEntry: InspectionEntryDescriptor): Promise<InspectionEntryDescriptor> {
    return super.post<InspectionEntryDescriptor>(
      new InspectionEntryDescriptor({
        id: undefined,
        href: undefined,

        inspectionId: inspectionEntry.inspectionId,
        dataEntryId: inspectionEntry.dataEntryId,
        reference: inspectionEntry.reference,
        technicalDescription: inspectionEntry.technicalDescription,
        publicDescription: inspectionEntry.publicDescription,
        isTechnicalDescriptionVisible: inspectionEntry.isTechnicalDescriptionVisible,
        inspectionEntryState: inspectionEntry.inspectionEntryState,
        stateDescription: inspectionEntry.stateDescription,

        modified: inspectionEntry.modified,
        deleted: inspectionEntry.deleted
      }));
  }

  public getInspectionEntries(view?: View): Promise<List<InspectionEntryDescriptor>> {
    return super.get<List<InspectionEntryDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, inspectionEntry: InspectionEntryDescriptor): Promise<InspectionEntryDescriptor> {
    return super.put<InspectionEntryDescriptor>(id, inspectionEntry);
  }

  public getById(id: string): Promise<InspectionEntryDescriptor> {
    return super.get<InspectionEntryDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/inspection.entry/inspection.entry.service.ts